export const getInitialState = () => ({
    fareOffersWithDetails: {},
    selectedFareToken: undefined
});
